import { ExerciseConfig, ExerciseConfigExecutionTypeEnum } from '@/generated';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';

export const ExecutionTypeDropdown = (props: { exerciseConfig: ExerciseConfig; updateExerciseConfig: (exerciseConfig: ExerciseConfig) => void }) => {
  const executionType = props.exerciseConfig.executionType ?? ExerciseConfigExecutionTypeEnum.Reps;
  const timing = props.exerciseConfig.timing ?? { intervals: [] };

  return (
    <FormControl fullWidth>
      <InputLabel id="exercise-execution-type-label">Type</InputLabel>
      <Select
        labelId="exercise-execution-type-label"
        label="Type"
        value={executionType}
        onChange={(event) => {
          const nextType = event.target.value;
          props.updateExerciseConfig({
            ...props.exerciseConfig,
            executionType: nextType,
            ...(nextType === ExerciseConfigExecutionTypeEnum.Intervals && timing.intervals.length === 0
              ? {
                  timing: {
                    ...timing,
                    initTimeSeconds: 5,
                    ...(props.exerciseConfig.trackPerSide ? { switchPauseSeconds: 5 } : {}),
                    intervals: [{ durationSeconds: 10, pauseAfterSeconds: 0 }],
                  },
                }
              : {}),
          });
        }}
      >
        <MenuItem value={ExerciseConfigExecutionTypeEnum.Reps}>Reps</MenuItem>
        <MenuItem value={ExerciseConfigExecutionTypeEnum.Duration}>Duration</MenuItem>
        <MenuItem value={ExerciseConfigExecutionTypeEnum.Intervals}>Intervals</MenuItem>
      </Select>
    </FormControl>
  );
};
